/*
 * @Descripttion:
 * @Author: 老板说这个需求很简单
 * @Date: 2025-05-27 17:42:43
 * @LastEditTime: 2025-05-27 17:51:14
 * @LastEditors: sudo_rm_rf
 */

import { DirectiveBinding, ref, VNode } from 'vue';
export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const dblclickHandler = (e: any) => {
      handler(e);
    };

    // 运行函数
    const handler = (e: any) => {
      // 执行传递给指令的方法
      binding.value(e);
    };

    //监听双击事件
    el.addEventListener('dblclick', dblclickHandler);

    // 将事件处理函数保存在元素的特定属性中，以便后续移除
    (el as any).__copyOnDblclickHandler = dblclickHandler;
  },
  onUnmounted(el: HTMLElement, binding: DirectiveBinding) {
    // 从元素中获取保存的事件处理函数，并移除事件监听器
    const dblclickHandler = (el as any).__copyOnDblclickHandler;
    el.removeEventListener('dblclick', () => {
      if (dblclickHandler) {
        //移除监听双击事件
        el.removeEventListener('dblclick', dblclickHandler);
        delete (el as any).__copyOnDblclickHandler;
      }
    });
  },
};
